export const SUBSCRIPTION_SECTION_IDS = {
  planBlock: 'plan-block',
  chooseMyPlan: 'choose-my-plan',
  chooseMyPlanSecond: 'choose-my-plan-second',
  firstSection: 'first_section',
  dogsCard: 'dogs_card',
  obtaining: 'whats_inside',
  cynologists: 'program_by_cynologists',
  guarantee: 'money_back',
  comments: 'users_love_woofz',
  getMyPlanButton: 'get-my-plan-button',
  startMyPlanButton: 'start-my-plan-button',
  specialDiscount: 'special-discount',
  startMyPlanButtonSecond: 'start-my-plan-button-second',
  planBlockButton: 'plan-block-button',
  interestingFact: 'interesting-fact',
  ourMission: 'our-mission',
  moneyBackGuarantee: 'money-back-guarantee',
  payment: 'payment',
  title: 'title',
  promoBlock: 'promo-block',
  stripeForm: 'stripe-form',
}

export const STICKY_BUTTON = 'sticky-button'
export const STICKY_HEADER = 'sticky-header'
export const STICKY_BANNER = 'sticky-banner'
export const STICKY_BANNER_DESKTOP = 'sticky-banner-desktop'
export const STICKY_HEADER_DESKTOP = 'sticky-header-desktop'
export const INVOXIA_TITLE = 'invoxia-title'
